<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            color="primary"
            type="gradient"
            class="mb-4 md:mb-0"
            @click="add"
            >Add New Data</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-input
          class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="keyword"
          @keyup="search"
          placeholder="Search..."
        />
      </div>
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>Imei</th>
              <th>Device Name</th>
              <th>Plate</th>
              <th>Share By</th>
              <th>Share To Username</th>
              <th>Date Share</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td colspan="8" class="text-center">Loading....</td>
            </tr>
          </tbody>
          <tbody v-else-if="data.length > 0">
            <tr v-for="(item, index) in data" :key="index">
              <td>{{ (page - 1) * per_page + (index + 1) }}</td>
              <td>{{ item.imei }}</td>
              <td>{{ item.device_name }}</td>
              <td>{{ item.plate }}</td>
              <td>{{ item.owner }}</td>
              <td>{{ item.share_to }}</td>
              <td>{{ item.date }}</td>
              <td style="width: 90px">
                <div v-if="item.id !== 0" class="flex">
                  <vx-tooltip text="Delete" position="top">
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-trash"
                      color="danger"
                      @click="del(item.id)"
                    ></vs-button>
                  </vx-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="8" class="text-center">No Data Available</td>
            </tr>
          </tbody>
        </table>

        <vs-pagination :total="n_page" v-model="page" goto></vs-pagination>
      </div>

      <vs-popup
        classContent="popup-example"
        :title="popupTitle"
        :active.sync="showPopup"
      >
        <template>
          <div class="vx-row mb-6">
            <div
              :class="
                actor.privilege <= 3
                  ? 'vx-col sm:w-1/1 w-full'
                  : 'vx-col sm:w-1/2 w-full'
              "
            >
              <label class="text-sm opacity-75">Share By</label>
              <v-select
                @search="searchUserBy"
                :options="UserByList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="user_by"
              />
            </div>

            <div class="vx-col sm:w-1/2 w-full" v-if="actor.privilege >= 4">
              <label class="text-sm opacity-75">Share To Username</label>
              <v-select
                @search="searchUserTo"
                :options="UserToList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="user_to"
              />
            </div>
          </div>

          <div class="vx-row mb-6" v-if="actor.privilege <= 3">
            <div class="vx-col sm:w-1/2 w-full">
              <label class="text-sm opacity-75">Branch of Share to</label>
              <v-select
                :options="branchList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="branch_to"
              />
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <label class="text-sm opacity-75">Share To Username</label>
              <v-select
                @search="searchUserTo"
                :options="UserToList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="user_to"
              />
            </div>
          </div>

          <hr />

          <div v-if="action == 'add'" class="vx-card p-6">
            <div class="vx-row">
              <div class="vx-col md:w-1/2">
                <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2"
                      >{{ page_gps * per_page_gps - (per_page_gps - 1) }} -
                      {{
                        row_total_gps - page_gps * per_page_gps > 0
                          ? page_gps * per_page_gps
                          : row_total_gps
                      }}
                      of {{ row_total_gps }}</span
                    >
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="updatePerPage_gps(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="updatePerPage_gps(25)">
                      <span>25</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="updatePerPage_gps(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="updatePerPage_gps(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>

              <div class="vx-col md:w-1/2">
                <vs-input
                  class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                  v-model="keyword_gps"
                  @keyup="search_gps"
                  placeholder="Search..."
                />
              </div>
            </div>

            <div class="table-container">
              <table class="table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Imei</th>
                    <th>Plate</th>
                    <th>Device Name</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody v-if="loading_gps">
                  <tr>
                    <td colspan="6" class="text-center">Loading....</td>
                  </tr>
                </tbody>
                <tbody v-else-if="data_gps.length > 0">
                  <tr v-for="(item, index) in data_gps" :key="index">
                    <td>{{ (page_gps - 1) * per_page_gps + (index + 1) }}</td>
                    <td>{{ item.imei }}</td>
                    <td>{{ item.plate }}</td>
                    <td>{{ item.device_name }}</td>
                    <td style="width: 90px">
                      <div v-if="item.id !== 0" class="flex">
                        <vs-checkbox v-model="list_imei" :vs-value="item.imei">
                        </vs-checkbox>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="6" class="text-center">No Data Available</td>
                  </tr>
                </tbody>
              </table>

              <vs-pagination
                :total="n_page_gps"
                v-model="page_gps"
              ></vs-pagination>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button
                id="submitBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="submit"
                >Submit</vs-button
              >
              <vs-button
                v-show="action === 'add'"
                color="warning"
                type="border"
                @click="reset"
                class="mb-2"
                >Reset</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },

  data() {
    return {
      actor: {},
      data: [],
      data_all: [],
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',
      loading: true,
      loading_gps: false,

      tempId: 0,
      user_by: '',
      branch_to: '',
      user_to: '',
      list_imei: [],

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      data_gps: [],
      page_gps: 1,
      per_page_gps: 10,
      row_total_gps: 0,
      keyword_gps: '',

      branchList: [],
      UserToList: [],
      UserByList: [],

      filter: {
        owner: ''
      },

      timer: null,
      timer_gps: null,
      notify: 'Server Error'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },
    n_page_gps() {
      return Math.ceil(this.row_total_gps / this.per_page_gps)
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    page_gps() {
      this.getVehicle()
    },

    per_page_gps() {
      if (this.page_gps != 1) this.page_gps = 1
      else this.getVehicle()
    },

    user_by: {
      handler(val) {
        if (val) {
          this.page_gps = 1
          this.getVehicle()
        } else {
          this.row_total_gps = 0
          this.data_gps = []
        }
      },
      deep: true
    },

    list_imei: {
      handler(val) {
        // console.log(val)
      },
      deep: true
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.initTable()
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800)
    },

    search_gps() {
      if (this.timer_gps) {
        clearTimeout(this.timer_gps)
        this.timer_gps = null
      }
      this.timer_gps = setTimeout(() => {
        this.page_gps = 1
        this.getVehicle()
      }, 800)
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    updatePerPage_gps(n) {
      this.per_page_gps = n
      this.getVehicle()
    },

    reset() {
      this.user_by = ''
      this.user_to = ''
      this.UserByList = []
      this.UserToList = []
      this.list_imei = []
    },

    getVehicle() {
      this.loading_gps = true
      this.$http
        .get(`${this.$api.endpoint}/share_vehicle/data_gps`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            page: this.page_gps,
            per_page: this.per_page_gps,
            search: this.keyword_gps,
            owner: this.user_by ? this.user_by.value : ''
          }
        })
        .then((res) => {
          this.row_total_gps = res.data.message.total
          this.data_gps = res.data.message.data

          this.loading_gps = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    initTable() {
      this.loading = true
      this.$http
        .get(
          `${this.$api.endpoint}/share_vehicle/datatable?page=${this.page}&per_page=${this.per_page}&search=${this.keyword}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.loading = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    getBranchList() {
      this.$http
        .get(`${this.$api.endpoint}/branch/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.branchList = res.data.message.data

          this.branch_to = this.branchList.find((item) => {
            return item.value === this.actor.branch
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    searchUserTo(search) {
      if (search.length >= 3)
        this.$http
          .get(`${this.$api.endpoint}/share_vehicle/share_to`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            params: {
              branch:
                this.actor.privilege >= 4
                  ? this.actor.branch
                  : this.branch_to.value,
              search: search
            }
          })
          .then((res) => {
            this.UserToList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
    },

    searchUserBy(search) {
      if (search.length >= 3)
        this.$http
          .get(`${this.$api.endpoint}/user/owner`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            params: {
              branch: this.actor.privilege >= 3 ? this.actor.branch : '',
              search: search
            }
          })
          .then((res) => {
            this.UserByList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
    },

    add() {
      // if (this.action === 'edit') this.reset()
      this.action = 'add'
      this.popupTitle = 'Add Share Vehicle'

      this.reset()
      this.getBranchList()

      if (this.actor.privilege >= 4) {
        this.user_by = {
          label: this.actor.username,
          value: this.actor.id
        }
      }

      this.showPopup = true
    },

    del(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Share Vehicle`,
        text: 'Are you sure want to Delete this data ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http
        .post(
          `${this.$api.endpoint}/share_vehicle/delete/${this.tempId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.notify = res.data.message.split('_').join(' ')

          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    submit() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let url = `${this.$api.endpoint}/share_vehicle/add`

      this.$http
        .post(
          url,
          {
            imei: this.list_imei,
            user_by: this.user_by ? this.user_by.value : '',
            user_to: this.user_to ? this.user_to.value : ''
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.notify = res.data.message.split('_').join(' ')
          this.showPopup = false

          this.initTable()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>
